<template>
  <v-dialog v-model="visible" max-width="700px">
    <v-card>
      <v-card-title class="text-uppercase">{{ titulo }}</v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12">
              <vue-select
                v-model="form.sede_id"
                class="style-chooser"
                placeholder="Seleccione Sede"
                label="nombre"
                :key="form.sede_id"
                :reduce="(op) => op.id"
                @input="obtenerSede()"
                :options="sedeItems">
                <template #option="{ nombre, origen }">
                  <span style="display: block; font-size: 1rem">{{ nombre }}</span>
                  <small>{{ origen.toUpperCase() }}</small>
                </template>
              </vue-select>
            </v-col>

            <v-col cols="12" style="padding-bottom: 0px !important">
              <v-text-field
                label="Banco"
                v-model="form.nombre"
                placeholder=" "
                outlined
                dense
                hide-details></v-text-field>
              <small v-for="error in errores.nombre" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" style="padding-bottom: 0px !important">
              <v-text-field
                class="my-1"
                label="Tipo de cuenta"
                v-model="form.descripcion"
                placeholder=" "
                outlined
                dense
                hide-details></v-text-field>
              <small v-for="error in errores.descripcion" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" style="padding-bottom: 0px !important">
              <v-text-field
                class="my-1"
                label="Numero de cuenta"
                v-model="form.nro"
                placeholder=" "
                outlined
                dense
                hide-details></v-text-field>
              <small v-for="error in errores.nro" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" style="padding-bottom: 0px !important">
              <v-select
                :items="estadoItems"
                label="Estado"
                item-text="descripcion"
                item-value="value"
                v-model="form.estado"
                placeholder=" "
                outlined
                dense
                hide-details />
              <small v-for="error in errores.estado" :key="error" class="text-danger">{{ error }}</small>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn color="blue darken-1" text @click.prevent="validar"> Guardar </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar" :timeout="3000">
      Complete los campos
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import ModalFormMixin from '../mixins/modal-form-mixin';
import CuentasPagadorasServices from '../services/cuentasPagadoras';
import { formatearErrores, obtenerTodasLasSedes } from '../utils';

export default {
  name: 'ModalFormCuentaPagadora',
  mixins: [ModalFormMixin],
  data() {
    return {
      snackbar: false,
      catalogo: null,
      estadoItems: [
        { descripcion: 'ACTIVO', value: 1 },
        { descripcion: 'INACTIVO', value: 0 },
      ],
      sedeItems: [],
    };
  },
  watch: {
    'form.nombre': function () {
      this.errores.nombre = [];
    },
    'form.descripciom': function () {
      this.errores.descripciom = [];
    },
    'form.nro': function () {
      this.errores.nro = [];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        sede_id: null,
        sede: '',
        nombre: '',
        descripcion: '',
        nro: '',
        estado: 1,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        sede_id: data.sede_id,
        sede: data.sede,
        nombre: data.nombre,
        descripcion: data.descripcion,
        nro: data.nro,
        estado: data.estado,
      };
    },
    obtenerSede() {
      this.form.sede = this.form.sede_id ? this.sedeItems.find((p) => p.id === this.form.sede_id).nombre : '';
    },
    async abrir(accion, data = []) {
      this.abrirMixin(accion, data);

      this.getSedes();
    },
    cerrar() {
      this.visible = false;
    },
    async registrar() {
      this.guardar();
    },
    async editar() {
      this.guardar();
    },
    async guardar() {
      this.enviando = true;
      this.errores = [];

      try {
        let response = null;

        if (this.form?.id) {
          response = await CuentasPagadorasServices.update(this.form.id, this.form);
        } else {
          response = await CuentasPagadorasServices.store(this.form);
        }

        this.$notify({
          group: 'notifications',
          title: this.nombreRecurso.toUpperCase(),
          text: response.data.mensaje,
          type: 'success',
        });
        this.$emit('actualizarListado');
        this.cerrar();
      } catch (error) {
        const { mensaje, errores } = error.response.data;
        const erroresFormateados = formatearErrores(errores);

        this.errores = errores;
        this.$notify({
          group: 'notifications',
          title: `${this.nombreRecurso}: ${mensaje}`,
          text: erroresFormateados,
          type: 'error',
        });

        window.console.log(error);
      } finally {
        this.enviando = false;
      }
    },
    async getSedes() {
      try {
        this.sedeItems = await obtenerTodasLasSedes(this.$apollo);
      } catch (error) {
        window.console.log(error);
      }
    },
  },
};
</script>

<style>
.v-dialog {
  align-items: flex-start;
}
</style>